// Dependencies
import axios from 'axios'
import lodash from 'lodash'

const baseUrl = `https://servicodados.ibge.gov.br/api/v1/localidades/estados`

export default async function getStates() {
  const resp = await axios.get(baseUrl)
  if (resp.data) {
    const values = resp.data.map((est: any) => {
      return { value: est.nome, text: est.sigla }
    })

    return lodash.orderBy(values, 'text')
  } else {
    return []
  }
}
